import { z } from "zod";

// export const signUpSchema = z
//   .object({
//     email: z.string().email({ message: "Invalid email address" }).trim(),
//     password: z
//       .string()
//       .trim()
//       .min(8, { message: "Password must be at least 8 characters" })
//       .refine((val) => /[^A-Za-z0-9]/.test(val), {
//         message: "Password must contain at least one symbol",
//       }),
//     confirmPassword: z.string().trim(),
//   })
//   .superRefine((data, ctx) => {
//     if (data.password !== data.confirmPassword) {
//       ctx.addIssue({
//         code: z.ZodIssueCode.custom,
//         message: "Passwords don't match",
//         path: ["confirmPassword"],
//       });
//     }
//   });

export const signUpSchema = z
  .object({
    email: z.string().email({ message: "Invalid email address" }).trim(),
    password: z.string().trim(),
    confirmPassword: z.string().trim(),
  })
  .superRefine((data, ctx) => {
    const { password, confirmPassword } = data;

    // Aggregate password errors
    if (password.length < 8 || !/[^A-Za-z0-9]/.test(password)) {
      const messages: string[] = [];
      if (password.length < 8) {
        messages.push("Password must be at least 8 characters");
      }
      if (!/[^A-Za-z0-9]/.test(password)) {
        messages.push("Password must contain at least one symbol");
      }

      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: messages.join("\n"), // 👈 multiple messages, each on new line
        path: ["password"],
      });
    }

    // Confirm password match
    if (password !== confirmPassword) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Passwords don't match",
        path: ["confirmPassword"],
      });
    }
  });

export const newPasswordSchema = z
  .object({
    password: z.string().trim(),
    confirmPassword: z.string().trim(),
  })
  .superRefine((data, ctx) => {
    const { password, confirmPassword } = data;

    // Aggregate password errors
    if (password.length < 8 || !/[^A-Za-z0-9]/.test(password)) {
      const messages: string[] = [];
      if (password.length < 8) {
        messages.push("Password must be at least 8 characters");
      }
      if (!/[^A-Za-z0-9]/.test(password)) {
        messages.push("Password must contain at least one symbol");
      }

      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: messages.join("\n"), // 👈 multiple messages, each on new line
        path: ["password"],
      });
    }

    // Confirm password match
    if (password !== confirmPassword) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Passwords don't match",
        path: ["confirmPassword"],
      });
    }
  });

export const signInSchema = z.object({
  email: z.string().email({ message: "Invalid email address" }).trim(),
  password: z.string().trim().min(8, { message: "Password is required" }),
});

export const verificationCodeSchema = z.object({
  email: z.string().email({ message: "Invalid email address" }).trim(),
  code: z.string().trim().min(6, { message: "Verification code is required" }),
});

export const resetPasswordSchema = z.object({
  email: z.string().email({ message: "Invalid email address" }).trim(),
});

export const forgotPasswordSchema = z
  .object({
    email: z.string().email({ message: "Invalid email address" }).trim(),
    verificationCode: z
      .string()
      .trim()
      .min(1, { message: "Verification code is required" }),
    password: z.string().trim(),
    confirmPassword: z.string().trim(),
  })
  .superRefine((data, ctx) => {
    const { password, confirmPassword } = data;

    // Aggregate password errors
    if (password.length < 8 || !/[^A-Za-z0-9]/.test(password)) {
      const messages: string[] = [];
      if (password.length < 8) {
        messages.push("Password must be at least 8 characters");
      }
      if (!/[^A-Za-z0-9]/.test(password)) {
        messages.push("Password must contain at least one symbol");
      }

      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: messages.join("\n"),
        path: ["password"],
      });
    }

    // Confirm password match
    if (password !== confirmPassword) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Passwords don't match",
        path: ["confirmPassword"],
      });
    }
  });
